import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmExperimentsContext: PsfSharePageFcmExperimentsContext,
	FcmExperimentsProvider: PsfSharePageFcmExperimentsContextProvider,
	useFcmExperiments: usePsfSharePageFcmExperiments,
	useAsyncFcmExperiments: useAsyncPsfSharePageFcmExperiments,
	prefetchFcmExperiments: prefetchPsfSharePageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'PsfSharePageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {},
	prefetch: true,
});

export type PsfSharePageFcmExperimentsState = ReturnType<typeof useAsyncPsfSharePageFcmExperiments>;
export type PsfSharePageFcmExperiments = LoadedStateData<PsfSharePageFcmExperimentsState>;
